import { ReactNode } from "react"
import {
  Modal as GoModal,
  ModalBody as GoModalBody,
  ModalFooter as GoModalFooter,
  ModalHeader as GoModalHeader,
} from "@gogoro/go-design"
import styled from "styled-components"

interface StyledModalHeaderProps {
  showCloseIcon?: boolean
  status?: "success" | "error" | "warning" | "info" | "question"
}
const StyledModalHeader = styled(GoModalHeader)<StyledModalHeaderProps>`
  background-color: #323237;
  svg {
    display: ${({ showCloseIcon }) => !showCloseIcon && "none"};
  }
`

interface StyledModalBodyProps {
  hasMinHeight: boolean
}

const StyledModalBody = styled(GoModalBody)<StyledModalBodyProps>`
  min-height: ${(props) => (props.hasMinHeight ? "246px" : "auto")};
`

interface ModalProps {
  isOpen?: boolean
  showCloseIcon?: boolean
  width?: string
  onToggle?: () => void
  title?: string
  footer?: ReactNode
  hasMinHeight?: boolean
  children?: ReactNode
  status?: "success" | "error" | "warning" | "info" | "question"
}

const Modal = ({
  isOpen = false,
  width = "100%",
  onToggle = () => {},
  title = "",
  status = "success",
  children,
  footer,
  showCloseIcon,
  hasMinHeight = true,
  ...restProps
}: ModalProps) => {
  return (
    <GoModal width={width} isOpen={isOpen} {...restProps}>
      <StyledModalHeader toggle={onToggle} showCloseIcon={showCloseIcon}>
        {title}
      </StyledModalHeader>
      <StyledModalBody hasMinHeight={hasMinHeight}>{children}</StyledModalBody>
      {footer && <GoModalFooter>{footer}</GoModalFooter>}
    </GoModal>
  )
}

export default Modal
